const typographyTablesActions = {
  clearFilter: 'Limpar',
  noResults: 'Nenhum resultado encontrado'
};

export default typographyTablesActions;
